import React, { Component } from "react";

import styles from "./cmsUser.module.scss";
import { withUsers } from "../../../shared/containers/containerUsers";
import { withPermissions } from "../../../shared/containers/containerPermissions";

import { states } from "../../../reducers/queriesStates";
import { Checkbox } from "@material-ui/core";
import Preloader from "../../../shared/items/static/preloader";

class CmsUserPermission extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChangeProcces: false,
      error: null,
    };
  }

  componentDidMount() {
    const { dataState, onGetPermissions } = this.props;

    if (dataState !== states.READY) {
      onGetPermissions({ count: 0 });
    }
  }

  componentDidUpdate(prevProps) {
    const { userPermissionDataState, errors } = this.props;
    const { isChangeProcces } = this.state;

    if (isChangeProcces && userPermissionDataState === states.FAILURE && prevProps.userPermissionDataState === states.REQUEST) {
      this.setState({ error: errors, isChangeProcces: false });

      setTimeout(() => {
        this.setState({ error: null });
      }, 3000);
    }

    if (isChangeProcces && userPermissionDataState === states.READY && prevProps.userPermissionDataState === states.REQUEST) {
      this.setState({ error: null, isChangeProcces: false });
    }
  }

  onChangePermission(e, value) {
    const { currentUser, onCreateUserPermission, onDeleteUserPermission, permission, classPermission } = this.props;

    if (value) {
      onCreateUserPermission(currentUser.id, permission, classPermission);
    } else {
      onDeleteUserPermission(currentUser.id, permission ,classPermission);
    }

    this.setState({ isChangeProcces: true });
  }

  render() {
    const { error, isChangeProcces } = this.state;
    const { checked, permission } = this.props;

    return (
      <div key={permission.id} className={styles.permissionItem}>
        <Checkbox
          id={permission.id}
          checked={checked}
          onChange={this.onChangePermission.bind(this)}
          color={"primary"}
          style={{ padding: "0px" }}
        />
        {permission.title}

        {isChangeProcces ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Preloader size={20} />
          </div>
        ) : (
          <div className={styles.error}>{error}</div>
        )}
      </div>
    );
  }
}

export default withPermissions(withUsers(CmsUserPermission));
